import { graphql } from 'gatsby';
import { Box } from '@twilio-paste/box';
import { Text } from '@twilio-paste/text';
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import * as React from 'react';
export default {
  graphql,
  Box,
  Text,
  Callout,
  CalloutTitle,
  CalloutText,
  React
};